import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.css']
})
export class ConfirmationPopupComponent implements OnInit {

  @Input() title: string;
  @Input() visible: string;
  @Input() confirmationMessage: string;
  @Input() ok_button_text: string;
  @Input() cancel_button_text: string;
  @Output() ok_button_event: EventEmitter<any> = new EventEmitter();
  @Output() cancel_button_event: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  popupOkAction(){
    this.visible = 'none';
    this.ok_button_event.emit()
  }

  popupCancelAction(){
    this.visible = 'none';
    this.cancel_button_event.emit()
  }

}
